// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"69":"47dd4fdb","203":"6e3ff47f","264":"93394441","662":"78704292"}[chunkId] + ".chunk.css";
};